angular
  .module('shared')
  .factory 'CommunicationTemplateCategories', (Restangular, $rootScope) ->
    params = $rootScope.toParams
    Restangular.one('gyms', params?.gymId).all('communication_template_categories')
